import { render } from "./P024.vue?vue&type=template&id=514eef42&scoped=true"
import script from "./P024.vue?vue&type=script&lang=js"
export * from "./P024.vue?vue&type=script&lang=js"

import "./P024.vue?vue&type=style&index=0&id=514eef42&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514eef42"]])

export default __exports__